import SocialMedia from '@features/footer/components/SocialMedia';
import styles from '@features/footer/Footer.styles';
import Contact from '@features/footer/components/Contact';
import { TSocialMedia } from '@features/footer/typescript';
type PropsType = {
  chatLink: string;
  phoneNr: string;
  socialMedia: TSocialMedia[];
};
const ContactData = ({
  chatLink,
  socialMedia,
  phoneNr
}: PropsType) => <div sx={styles.footerContactContainer(false)}>
    <Contact chatLink={chatLink} phoneNr={phoneNr} />
    <SocialMedia media={socialMedia} />
  </div>;
export default ContactData;